import React, { useEffect } from "react";
import { format } from "date-fns";
import classNames from "classnames";
import ModalPortal from "components/app/_common/ModalPortal";
import { vdmDashboardUtils } from "redux/app/vdmdashboard/utils";
import { ICalendarDot } from "redux/app/vdmdashboard/@types";

const { toLocalMidnight } = vdmDashboardUtils;

interface ICNRRecordInModal {
	id: string;
	intlDateLineRecord: boolean;
}

export interface ICNRIdSelectionModalContentProps {
	availableCnrs?: ICNRRecordInModal[];
	selectedCNRId: string;
	setModalCNRId: (cnrId: string) => void;
	handleCnrSelection: (cnrId: string, intlDateLine: boolean) => void;
	onClose: () => void;
	isOpen: boolean;
	modalDate: string;
	modalCNRId: string;
	onSelect: (cnrId: string) => void;
	closeCNRModal: () => void;
}

function CNRIdSelectionModalContent(props: ICNRIdSelectionModalContentProps) {
	const {
		availableCnrs = [],
		onClose,
		isOpen,
		modalDate,
		modalCNRId,
		handleCnrSelection,
		onSelect,
		closeCNRModal,
		selectedCNRId,
		setModalCNRId,
	} = props;

	useEffect(() => {
		if (selectedCNRId) {
			setModalCNRId(selectedCNRId);
		}

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<ModalPortal width={332} isActive={isOpen} onClose={() => onClose()}>
			<div className="flex justify-center rounded">
				<div className="bg-white rounded-xl p-6 max-w-md w-full shadow-lg border border-gray-100">
					<div className="mb-5">
						<h3 className="text-lg font-medium text-gray-900 mb-2">
							Select Date Type
						</h3>
						<p className="text-sm text-gray-600">
							{modalDate
								? format(toLocalMidnight(modalDate), "MMMM d, yyyy")
								: ""}
						</p>
					</div>

					<div className="space-y-3 mb-6">
						{availableCnrs.map((cnr) => (
							<button
								key={cnr.id}
								onClick={() =>
									handleCnrSelection(cnr.id, cnr.intlDateLineRecord)
								}
								className={`w-full p-4 rounded-lg border transition-all duration-200 flex items-center justify-between ${
									modalCNRId === cnr.id
										? "border-blue-500 bg-blue-50 shadow-sm"
										: "border-gray-200 hover:border-gray-300 hover:bg-gray-50"
								}`}
							>
								<div className="flex items-center">
									<div
										className={`w-3 h-3 rounded-full mr-3 ${
											cnr.intlDateLineRecord ? "bg-green-400" : "bg-red-500"
										}`}
									/>
									<span className="font-medium text-gray-900 text-base">
										{cnr.intlDateLineRecord ? "Repeated date" : "Normal date"}
									</span>
								</div>
								<div
									className={`w-5 h-5 rounded-full border-2 flex items-center justify-center ${
										modalCNRId === cnr.id
											? "border-blue-500 bg-blue-500"
											: "border-gray-300"
									}`}
								>
									{modalCNRId === cnr.id && (
										<div className="w-2 h-2 rounded-full bg-white"></div>
									)}
								</div>
							</button>
						))}
					</div>

					<div className="flex justify-end gap-3">
						<button
							onClick={() => closeCNRModal()}
							className="px-4 py-2.5 text-gray-700 hover:bg-gray-100 rounded-lg font-medium transition-colors"
						>
							Cancel
						</button>
						<button
							onClick={() => {
								onSelect(modalCNRId);
							}}
							className="px-4 py-2.5 bg-blue-600 text-white rounded-lg font-medium hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-colors"
						>
							Select
						</button>
					</div>
				</div>
			</div>
		</ModalPortal>
	);
}

export default CNRIdSelectionModalContent;
